import { useEffect } from "react";

import "./SnowBallsAnimation.css";

const SnowBallsAnimation: React.FC = () => {
  useEffect(() => {
    let snowflakesContainer = document?.querySelector(".snowflakes");
    for (let i = 0; i < 200; i++) {
      const snowflake = document?.createElement("div");
      snowflake.className = "snowflake";

      const randomSize = Math.random() * 5 + 5;
      snowflake.style.width = `${randomSize}px`;
      snowflake.style.height = `${randomSize}px`;

      const randomPosition = Math.random() * 100;
      snowflake.style.left = `${randomPosition}vw`;

      const randomAnimationDuration = Math.random() * 20 + 1;
      snowflake.style.animationDuration = `${randomAnimationDuration}s`;

      snowflakesContainer && snowflakesContainer.appendChild(snowflake);
    }
  }, []);

  return <div className='snowflakes'></div>;
};

export default SnowBallsAnimation;
